const SkeletonBox = ({ className = "" }: { className?: string }) => (
  <div className={`animate-pulse rounded bg-gray-300 dark:bg-gray-700 ${className}`} />
);

const CashClosingSkeleton = () => {
  return (
    <div className="rounded-sm border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark">

      {/* HEADER */}
      <div className="flex items-center justify-between border-b border-stroke p-4 dark:border-strokedark">

        <div className="grid grid-cols-3 gap-6 w-full">

          {/* Usuario */}
          <div className="flex flex-col gap-2">
            <SkeletonBox className="h-3 w-16" />
            <SkeletonBox className="h-4 w-48" />
          </div>

          {/* Sesión */}
          <div className="flex flex-col gap-2">
            <SkeletonBox className="h-3 w-16" />
            <SkeletonBox className="h-4 w-56" />
          </div>

          {/* Fecha */}
          <div className="flex flex-col gap-2">
            <SkeletonBox className="h-3 w-16" />
            <SkeletonBox className="h-4 w-40" />
          </div>

        </div>

        <SkeletonBox className="ml-4 h-10 w-28 rounded-md" />
      </div>

      {/* BODY */}
      <div className="grid grid-cols-1 xl:grid-cols-2">

        {/* IZQUIERDA */}
        <div className="p-6">

          <SkeletonBox className="mb-6 h-4 w-40" />

          {/* Card método pago */}
          <div className="rounded-md border border-stroke p-4 dark:border-strokedark">
            <div className="flex items-center justify-between">
              <SkeletonBox className="h-4 w-40" />
              <SkeletonBox className="h-4 w-16" />
            </div>
          </div>

        </div>

        {/* DERECHA */}
        <div className="border-l border-stroke p-6 dark:border-strokedark">

          <SkeletonBox className="mb-6 h-4 w-48" />

          <div className="space-y-4">

            {/* Apertura */}
            <div className="flex justify-between">
              <SkeletonBox className="h-4 w-24" />
              <SkeletonBox className="h-4 w-16" />
            </div>

            {/* Ventas */}
            <div className="flex justify-between">
              <SkeletonBox className="h-4 w-24" />
              <SkeletonBox className="h-4 w-16" />
            </div>

            {/* Divider */}
            <div className="border-t border-dashed pt-4 flex justify-between">
              <SkeletonBox className="h-4 w-32" />
              <SkeletonBox className="h-5 w-20" />
            </div>

          </div>

        </div>

      </div>

      {/* FOOTER */}
      <div className="grid grid-cols-1 md:grid-cols-4 border-t border-stroke dark:border-strokedark">

        {Array.from({ length: 4 }).map((_, i) => (
          <div key={i} className="p-4 flex flex-col gap-2">
            <SkeletonBox className="h-3 w-28" />
            <SkeletonBox className="h-5 w-20" />
          </div>
        ))}

      </div>

    </div>
  );
};

export default CashClosingSkeleton;